var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardLimit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M30.369 27.966v-2.619c0-2.288 1.523-4.142 3.403-4.142.938 0 1.791.461 2.408 1.211.612.75.995 1.785.995 2.931v2.619M35.483 36.598c2.175 0 3.937-2.237 3.937-4.996v-3.525H28.463v3.525c0 2.759 1.763 4.996 3.937 4.996h3.083zM3.1 12.815h33.438M12.652 21.818h8.223"
  }), /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M22.891 28.902H8.811c-3.154 0-5.712-2.148-5.712-4.798V10.72c0-2.65 2.557-4.798 5.712-4.798h22.015c3.154 0 5.712 2.148 5.712 4.798v4.973"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 7.892,
    cy: 21.818,
    r: 1.445
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardLimit);
export default __webpack_public_path__ + "static/media/cardLimit.e97643b532ba78e0eb78d66403901a0f.svg";
export { ForwardRef as ReactComponent };